<template>
  <a-tooltip placement="bottom" @click="toDetail">
    <template slot="title">
      <span>提示文档</span>
    </template>
    <img src="/common/notice.png" style="height:23px;width:23px" />
  </a-tooltip>
</template>

<script>
export default {
  methods: {
    toDetail() {
      window.open('https://www.feishu.cn/docs/doccnycUWroRm08J7qz8Qf7uOLh');
    }
  }
};
</script>

<style lang="less" scoped></style>
